import type { TextStyle } from 'tamagui';

export const shorthands = {
  // text
  ta: 'textAlign',

  // view
  ac: 'alignContent',
  ai: 'alignItems',
  b: 'bottom',
  bc: 'borderColor',
  bbrr: 'borderBottomRightRadius',
  bblr: 'borderBottomLeftRadius',
  bg: 'backgroundColor',
  bw: 'borderWidth',
  bbw: 'borderBottomWidth',
  btw: 'borderTopWidth',
  blw: 'borderLeftWidth',
  brw: 'borderRightWidth',
  br: 'borderRadius',
  btlr: 'borderTopLeftRadius',
  btrr: 'borderTopRightRadius',
  col: 'color',
  cur: 'cursor',
  fd: 'flexDirection',
  fs: 'fontSize',
  fw: 'fontWeight',
  grow: 'flexGrow',
  h: 'height',
  jc: 'justifyContent',
  l: 'left',
  m: 'margin',
  maxH: 'maxHeight',
  maxW: 'maxWidth',
  mb: 'marginBottom',
  minH: 'minHeight',
  minW: 'minWidth',
  ml: 'marginLeft',
  mr: 'marginRight',
  mt: 'marginTop',
  mx: 'marginHorizontal',
  my: 'marginVertical',
  o: 'opacity',
  p: 'padding',
  pb: 'paddingBottom',
  pl: 'paddingLeft',
  pr: 'paddingRight',
  pt: 'paddingTop',
  px: 'paddingHorizontal',
  py: 'paddingVertical',
  pos: 'position',
  r: 'right',
  select: 'userSelect',
  self: 'alignSelf',
  shrink: 'flexShrink',
  t: 'top',
  w: 'width',
  z: 'zIndex'
} as const;

export type Shorthands = typeof shorthands;
export type ShorthandKeys = keyof Shorthands;

type NonDefinedShorthandValues = Exclude<keyof TextStyle, Shorthands[ShorthandKeys]>;

// we want no types but compiler/runtime uses it for short classname generation
const nonCompilerShorthands: [string, NonDefinedShorthandValues][] = [
  ['fwr', 'flexWrap'],
  ['ff', 'fontFamily'],
  ['fst', 'fontStyle'],
  ['tt', 'textTransform'],
  ['td', 'textDecorationLine'],
  ['va', 'verticalAlign'],
  ['ws', 'whiteSpace'],
  // @ts-ignore
  ['wb', 'wordBreak'],
  ['ww', 'wordWrap'],
  ['brc', 'borderRightColor'],
  ['bs', 'borderStyle'],
  ['btc', 'borderTopColor'],
  ['pe', 'pointerEvents'],
  ['ov', 'overflow'],
  ['dsp', 'display'],
  ['ls', 'letterSpacing'],
  ['lh', 'lineHeight'],
  ['bxs', 'boxSizing'],
  ['bxsh', 'boxShadow'],
  ['ox', 'overflowX'],
  ['oy', 'overflowY']
];

// Merge the non-compiler shorthands into the main object
Object.assign(shorthands, Object.fromEntries(nonCompilerShorthands));
